<template>
  <v-layout>

    <v-dialog v-model="showInvoiceDialog"
              persistent
              lazy
              @input="v => v"
              max-width="500">
      <v-card :class="{'pa-4': !$vuetify.breakpoint.smAndDown}">
        <v-layout column>
          <v-card>
            <v-toolbar>
              <img class="align-center cursor-pointer"
                   height="38" width="38"
                   src="/static/xero-logo-blue.svg" />
              <v-toolbar-title>{{ contractsExportTitle }}</v-toolbar-title>
            </v-toolbar>
            <v-list>

            </v-list>
          </v-card>
          <v-alert type="warning"
                   v-if="isXeroConnected(invoicingCompany)"
                   :value="daysUntilXeroCredentialsExpire(invoicingCompany) < 8">
            <v-layout row wrap>
              <v-flex xs8 v-if=isXeroConnected(invoicingCompany)>
                <span>Your Xero Credentials expire in {{ daysUntilQuickbooksCredentialsExpire(invoicingCompany) }} days.</span>
              </v-flex>
<!--              <v-flex xs4>-->
<!--                <v-btn color="accent" :to="`/companies/${invoicingCompany.id}/profile#xero`">-->
<!--                  Fix It-->
<!--                </v-btn>-->
<!--              </v-flex>-->
            </v-layout>
          </v-alert>
          <v-spacer class="mb-3" />

          <div>
            <v-stepper v-model="exportXeroStep">
<!--              <v-stepper-header>-->
<!--                <v-stepper-step step="1" :complete="exportXeroStep > 1">Loads</v-stepper-step>-->
<!--                <v-stepper-step step="2" :complete="exportXeroStep > 2">Service</v-stepper-step>-->
<!--              </v-stepper-header>-->

              <v-stepper-items>
                <v-stepper-content step="1">
                  <h3>Amount, Customer, and Product</h3>
                  <span class="font-weight-light">
                    Select {{ $t('site-title') }} customer and sales item from your Xero Account
                  </span>
                  <v-list three-line>
                    <v-list-tile>
                      <v-list-tile-content>
                        <v-list-tile-sub-title>Full Invoiced Amount</v-list-tile-sub-title>
                        <v-list-tile-title class="font-weight-bold">${{ this.invoicedAmount }}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile v-if="false">
                      <v-float-field label="Full Invoiced Amount ($)"
                                     disabled
                                     v-model="invoicedAmount"
                                     :error-messages="errors.first('amount', 'step1')"
                                     data-vv-as="Invoiced Amount"
                                     data-vv-name="amount"
                                     data-vv-scope="step1"
                                     v-validate="'required'"/>
                    </v-list-tile>
                    <v-list-tile>
                      <v-autocomplete
                        :items="customers"
                        :loading="loadingCustomers"
                        label="Xero Customer"
                        item-text="xeroName"
                        item-value="xeroContactId"
                        v-model="xroCustomer"
                        return-object
                        :disabled="loadingCustomers"
                        :error-messages="errors.first('customer', 'step1')"
                        data-vv-as="Xero Customer"
                        data-vv-name="customer"
                        data-vv-scope="step1"
                        v-validate="'required'">
                        <template slot="item" slot-scope="slotItems">
                          <v-layout column>
                            <div class="title mr-3 mt-1 primary--text">
                              <span v-if="customerContactName(slotItems.item)">
                                <v-icon color="primary">person_outline</v-icon>
                                {{ customerDisplayName(slotItems.item) }}
                              </span>
                              <span v-else>
                                <v-icon color="primary" v-if="slotItems.item.xeroContactId">business</v-icon>
                                <!-- Issue #379 -->
<!--                                <v-icon color="transparent" v-else>add_circle</v-icon>-->
                                {{ customerCompanyName(slotItems.item) }}
                              </span>
                            </div>
                            <div class="grey--text caption"
                                 v-if="customerCompanyName(slotItems.item) && customerContactName(slotItems.item)">
                              <v-icon color="primary">person_outline</v-icon>
                              <span>{{ customerContactName(slotItems.item) }}</span>
                              <span v-if="customerCompanyName(slotItems.item) !== customerDisplayName(slotItems.item)"
                                    class="font-italic font-weight-light">
                              {{ customerDisplayName(slotItems.item) }}
                            </span>
                            </div>

                          </v-layout>
                        </template>
                      </v-autocomplete>
                      <v-list-tile-avatar class="pl-3">
                        <v-btn fab small flat color="accent" :disabled="loadingCustomers">
                          <v-icon color="accent" @click="refreshXeroContacts(invoicingCompany.id)">refresh</v-icon>
                        </v-btn>
                      </v-list-tile-avatar>
                    </v-list-tile>

<!--                    <v-list-tile>-->
<!--                      <v-list-tile-content>-->
<!--                        <v-list-tile-title class="font-weight-bold">Product or Service</v-list-tile-title>-->
<!--                        <v-list-tile-sub-title>invoice sales line item</v-list-tile-sub-title>-->
<!--                      </v-list-tile-content>-->
<!--                    </v-list-tile>-->

                    <v-list-tile class="pt-1">
                      <v-autocomplete
                        class="mt-2"
                        :items="salesItems"
                        :loading="loadingSalesItems"
                        :disabled="loadingSalesItems"
                        label="Xero Sales Item"
                        item-text="Description"
                        item-value="ItemId"
                        v-model="xroSalesItem"
                        return-object
                        :error-messages="errors.first('salesItem', 'step1')"
                        data-vv-as="Xero Sales Item"
                        data-vv-name="salesItem"
                        data-vv-scope="step1"
                        v-validate="'required'"
                      >
                      </v-autocomplete>
                      <v-list-tile-avatar class="pl-3">
                        <v-btn fab small flat color="accent" :disabled="loadingSalesItems">
                          <v-icon color="accent" @click="refreshXeroSalesItems(invoicingCompany.id)">refresh</v-icon>
                        </v-btn>
                      </v-list-tile-avatar>
                    </v-list-tile>
                  </v-list>
                  <v-spacer />

                  <v-btn block large
                         :disabled="errors.any('step1') || loading"
                         @click="exportXeroInvoice"
                         :color="btnColor">
                    <v-icon large color="white" class="pr-2">
                        account_balance
                    </v-icon>
                    Export to Xero
                  </v-btn>

                  <v-btn block flat
                         :disabled="loading"
                         :color="btnColor" @click="cancelXeroModal">
                    Cancel
                  </v-btn>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </div>

        </v-layout>
      </v-card>
    </v-dialog>

    <v-badge right overlap
             color="transparent">
      <template slot="badge">
        <v-icon color="#13b5ea darken-1">
          new_releases
        </v-icon>
      </template>
      <v-xero-btn @click="openXeroModal"
                  :disabled="disabled"
                  :loading="loading">
      </v-xero-btn>
    </v-badge>
  </v-layout>
</template>

<script>

import VXeroBtn from './XeroButton.vue';
import VFloatField from '@/components/VFloatField';
import API from '@/api/index';
import loadTransactionsMixin from '../../mixins/loadTransactionsMixin';
import xeroMixin from '../../mixins/xeroMixin';
import _ from 'lodash';

export default {
  name: 'VXeroBillingBtn',
  components: { VXeroBtn, VFloatField },
  mixins: [
    loadTransactionsMixin,
    xeroMixin,
  ],
  props: {
    invoicingCompany: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    selections: {
      type: Array,
      default: null
    },
    contract: {
      type: Object,
      default: null,
    },
    multiSelectMode: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      loading: false,
      showInvoiceDialog: false,
      selectedItemId: "ae0170e7-8e2a-43a5-baad-b7d3acebc385",
      selectedCustomerContactId: "e48112b9-e1f6-4e36-ae3e-963c5ea06664",

      exportXeroStep: null,
      xroCustomer: null,
      xroSalesItem: null,
      invoicedAmount: null,
    }
  },
  computed: {
    isMultiSelectMode() {
      return this.multiSelectMode;
    },
    contractsExportTitle() {
      return 'Create Xero Invoice';
    },
    btnColor() {
      return 'primary'; // this.createInvoice ? 'primary' : 'accent';
    },
    loadingCustomers() {
      return this.contactsStatus[this.invoicingCompany.id] || false;
    },
    customers() {
      return this.loadingCustomers ? [] : this.xeroCustomers(this.invoicingCompany.id);
    },
    vendors() {
      return this.xeroVendors(this.invoicingCompany.id);
    },
    salesItems() {
      return this.loadingSalesItems ? [] : this.xeroSalesItems(this.invoicingCompany.id);
    },
    loadingSalesItems() {
      return this.salesItemsStatus[this.invoicingCompany.id] || false;
    },
    initialInvoicedAmount() {
      if (this.contract) {
        return this.contract.amount;
      }
      if (this.selections && this.selections.length > 0) {
        return _.chain(this.selections)
          .map(s => s.amount)
          .sum();
      }

      return null;
    }
  },
  methods: {
    async openXeroModal() {
      this.showInvoiceDialog = true;
      this.exportXeroStep = 1;

      if (this.invoicedAmount == null) {
        this.invoicedAmount = this.initialInvoicedAmount;
      }

    },
    cancelXeroModal() {

      // reset state
      this.xroCustomer = null;
      this.xroSalesItem = null;
      this.invoicedAmount = null;
      this.exportXeroStep = 1;

      this.showInvoiceDialog = false;
    },
    async exportXeroInvoice() {
      // TODO: validate
      console.log('ExportXeroInvoice', this.contract, this.selections);

      if (this.contract) {
        await this.createMultiLoadContractInvoice([this.contract]);
      } else {
        if (this.selections && this.selections.length > 0) {
          await this.createMultiLoadContractInvoice();
        } else {
          console.log('Select a few things buddy');
          this.showInvoiceDialog = false;
        }
      }
    },
    async createMultiLoadContractInvoice(selected = this.selections) {

      const valid = await this.$validator.validateAll('step1');
      if (!valid) {
        return;
      }

      const invoicedAmount = _.chain(selected || [])
        .map(s => s.amount)
        .sum();
      const contractIds = (selected || []).map(s => s.id) ;

      const body = {
        productId: this.xroSalesItem.ItemID,
        invoicedAmount,
        vendorInvoice: {
          systemCustomerId: this.xroCustomer.xeroContactId,
        },
        contractIds
      };

      try {
        this.loading = true;
        const created = await API.xero.createConsolidatedInvoice({ companyId: this.invoicingCompany.id, body });

        const document = created.data;
        this.$store.dispatch('applications/setSuccessNotification', {
          message: `Document ${document.InvoiceNumber} Created`,
        });

        this.$emit('invoiceCreated');

        this.loadCompanyTransactions(this.invoicingCompany.id);

        this.cancelXeroModal();

      } catch (err) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: `Xero Export Request Failed. Try again. ${err.message}`,
        });
      } finally {
        this.showInvoiceDialog = false;
        this.loading = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/xero/XeroBillingButton.vue